var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row substanceTableCss" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "substanceTable",
              attrs: {
                title: "구성물질 목록",
                tableId: "substanceTable",
                columns: _vm.grid.columns,
                data: _vm.grid.data,
                columnSetting: false,
                selection: "multiple",
                rowKey: "mdmMaterialSubstancesId",
                filtering: false,
                usePaging: false,
                hideBottom: true,
                gridHeight: "350px",
              },
              on: { "table-data-change": _vm.tableDataChange },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      [
                        col.name === "msdslink" && props.row.mttrid != ""
                          ? _c(
                              "q-chip",
                              {
                                attrs: {
                                  color: "blue",
                                  clickable: true,
                                  "text-color": "white",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return (() =>
                                      _vm.msdslink(props.row)).apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v(" MSDS ")]
                            )
                          : _vm._e(),
                      ],
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              label: "환경부-화학물질정보 연동 추가",
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addApiRow },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "추가", icon: "add" },
                            on: { btnClicked: _vm.addrow },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "삭제", icon: "remove" },
                            on: { btnClicked: _vm.removeRow },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "저장", icon: "save" },
                            on: { btnClicked: _vm.saveSubstance },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "q-toolbar",
            { staticClass: "custom-split-tab-card bg-grey-3 q-pa-none" },
            [
              _c(
                "q-tabs",
                {
                  staticClass: "text-grey custom-split-tab2",
                  attrs: {
                    dense: "",
                    "inline-label": "",
                    "active-color": "primary",
                    "indicator-color": "primary",
                    "narrow-indicator": "",
                    align: "left",
                  },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                _vm._l(_vm.nationItems, function (nation, index) {
                  return _c(
                    "q-tab",
                    {
                      key: index,
                      attrs: { name: nation.code, label: nation.codeName },
                    },
                    [
                      _c("country-flag", {
                        staticClass: "lanauageFlag",
                        attrs: { country: nation.code },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.nationItems, function (nation, index) {
            return _c(
              "q-tab-panels",
              {
                key: index,
                staticClass: "tabcard-panel",
                attrs: { animated: "" },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "q-tab-panel",
                  { attrs: { name: nation.code } },
                  [
                    _c("c-table", {
                      ref: "innertable",
                      refInFor: true,
                      staticClass: "topcolor-orange",
                      attrs: {
                        tableId: "innertable",
                        title: "구성물질별 규제사항",
                        columns: _vm.gridRegulItem.columns,
                        data: _vm.nationData,
                        columnSetting: false,
                        filtering: false,
                        usePaging: false,
                        hideBottom: true,
                        editable: false,
                        gridHeight: _vm.innertableHeight,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "customArea",
                            fn: function ({ props }) {
                              return [
                                _c(
                                  "q-btn-group",
                                  { attrs: { outline: "" } },
                                  [
                                    _vm.editable
                                      ? _c("c-btn", {
                                          attrs: { label: "추가", icon: "add" },
                                          on: {
                                            btnClicked: function ($event) {
                                              return _vm.addSubstanceRegs(
                                                props.row,
                                                nation.code
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  _vm.getNationFilter(
                                    props.row.nations,
                                    nation.code
                                  ),
                                  function (item, index) {
                                    return _c(
                                      "q-chip",
                                      {
                                        key: index,
                                        staticClass: "lawchemChip",
                                        attrs: { square: "" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm._v(
                                              " [" +
                                                _vm._s(
                                                  item.regulationBillName
                                                ) +
                                                "] " +
                                                _vm._s(item.regulatedItemName) +
                                                " "
                                            ),
                                            _c(
                                              "q-popup-proxy",
                                              {
                                                staticClass: "regulItemDescPop",
                                                attrs: {
                                                  "transition-show": "flip-up",
                                                  "transition-hide":
                                                    "flip-down",
                                                },
                                              },
                                              [
                                                _c(
                                                  "c-card",
                                                  {
                                                    staticClass:
                                                      "cardClassDetailForm regulItemDesc",
                                                    attrs: {
                                                      title: "규제대상 사유",
                                                      bgClass: "light-blue",
                                                      titleClass: "white",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "card-button" },
                                                      [
                                                        _c(
                                                          "q-btn-group",
                                                          {
                                                            attrs: {
                                                              outline: "",
                                                            },
                                                          },
                                                          [
                                                            _c("q-btn", {
                                                              attrs: {
                                                                flat: "",
                                                                color: "white",
                                                                icon: "save",
                                                                dense: "",
                                                                size: "12px",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.saveRegulItemDesc(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "template",
                                                      { slot: "card-detail" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12",
                                                          },
                                                          [
                                                            _c("c-textarea", {
                                                              attrs: {
                                                                editable:
                                                                  _vm.editable,
                                                                rows: 2,
                                                                label: "",
                                                                name: "regulatedReason",
                                                              },
                                                              model: {
                                                                value:
                                                                  item.regulatedReason,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "regulatedReason",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.regulatedReason",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("q-avatar", {
                                          staticClass: "cursor-pointer",
                                          attrs: {
                                            icon: "clear",
                                            color: "red",
                                            "text-color": "white",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteRegulItem(item)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }